<app-si-dialog
	[hideHeader]="true"
	[modalFooterClasses]="'si-dialog__footer--centered'"
	[cancelButtonText]="data.cancelButtonText || 'Cancel'"
	[saveButtonText]="data.saveButtonText || 'Ok'"
	[saveButtonClass]="data.isDestructive ? 'mat-error' : null"
	[hideSaveButton]="data.hideSaveButton"
	[modalBodyClasses]="data.modalBodyClasses"
	(save)="onConfirmation(true)"
>
	<ng-template appDialogBody>
		<div class="px-16 py-8">
			<ng-container *ngIf="!data.isShowButton; else messageDialogTemplate">
				<div class="flex items-center gap-5">
					<fa-icon class="text-danger shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<p class="m-0 max-w-[32rem] break-words text-base leading-6">
					Are you sure you want to {{ data.title | lowercase }}<span *ngIf="data.name"> "{{ data.name }}"</span>?
				</p>
				</div>
			</ng-container>

			<ng-template #messageDialogTemplate>
				<div class="flex items-center gap-5">
					<fa-icon class="shrink-0 mt-0.5" [ngClass]="data.isDestructive ? 'text-danger' : 'text-primary-light'" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
				<p class="m-0 max-w-[32rem] break-words text-base leading-6">
					{{ data.confirmMessage || "You haven't saved your changes. Are you sure you want to cancel?" }}
				</p>
				</div>
			</ng-template>
		</div>
	</ng-template>
</app-si-dialog>
